import notaire from '../../assets/images/svg/004-A-notaire.png';
import securitesociale from '../../assets/images/svg/004-A-securitesocial.png';
import banque from '../../assets/images/svg/004-A-banque.svg';
import mutuelle from '../../assets/images/svg/004-A-mutuelle.svg';
import assurance from '../../assets/images/svg/100-assurance.svg';
import assurancehabitation from '../../assets/images/svg/100-assurancehabitation.svg';
import fournisseureau from '../../assets/images/svg/004-A-fournisseureau.svg';
import fournisseurelectricite from '../../assets/images/svg/004-A-fournisseurelectricite.svg';
import telephonemobile from '../../assets/images/svg/004-A-telephonemobile.svg';
import centreimpots from '../../assets/images/svg/004-A-dgfip.png';
import caf from '../../assets/images/svg/004-A-Caf.svg';
import sport from '../../assets/images/svg/004-B-sport.svg';
import internet from '../../assets/images/svg/004-B-internet.svg';
import presse from '../../assets/images/svg/004-B-presse.svg';
import loisirs from '../../assets/images/svg/004-B-loisirs.svg';
import voitures from '../../assets/images/svg/004-B-voiture.svg';
import transport from '../../assets/images/svg/004-B-transport.svg';
import entretienmaison from '../../assets/images/svg/004-B-entretienmaison.svg';
import securite from '../../assets/images/svg/004-B-securite.svg';
import soinesthetique from '../../assets/images/svg/004-B-soinesthetique.svg';
import domicile from '../../assets/images/svg/004-B-domicile.svg';
import musique from '../../assets/images/svg/004-B-musique.svg';
import cartepaiment from '../../assets/images/svg/004-B-cartepaiment.svg';
import multimedia from '../../assets/images/svg/004-B-multimedia.svg';
import tech from '../../assets/images/svg/004-B-tech.svg';
import tv from '../../assets/images/svg/004-B-tv.svg';
import solidaire from '../../assets/images/svg/004-B-solidaire.svg';
import fournisseurgas from '../../assets/images/svg/004-A-fournisseurgas.svg';
import facebook from '../../assets/images/svg/020-facebook.svg';
import youtube from '../../assets/images/svg/019-youtube.svg';
import instagram from '../../assets/images/svg/018-instagram-sketched.svg';
import snapchat from '../../assets/images/svg/017-snapchat.svg';
import twitter from '../../assets/images/svg/023-twitter-1.svg';
import x from '../../assets/images/svg/023 - X.svg';
import linkedin from '../../assets/images/svg/022-linkedin.svg';
import whatsapp from '../../assets/images/svg/021-whatsapp.svg';
import tiktok from '../../assets/images/svg/016-tiktok.svg';
import voiture from '../../assets/images/svg/025-car.svg';
import bateau from '../../assets/images/svg/026-boat.svg';
import moto from '../../assets/images/svg/027-motorcycle.svg';
import scooter from '../../assets/images/svg/026-road.svg';
import loisir from '../../assets/images/svg/029-football-ball.svg';
import pet from '../../assets/images/svg/028-pet-food.svg';
import mobile from '../../assets/images/svg/024-furniture.svg';
import personnes from '../../assets/images/svg/024-account.svg';
import autres from '../../assets/images/svg/004-B-autres.svg';
import reseauxsociaux from '../../assets/images/svg/104-social-media.svg';
import assurancelife from '../../assets/images/svg/100-assurancelife.svg';
import assurancedeath from '../../assets/images/svg/100-death-assurance.svg';
import assurancefuneral from '../../assets/images/svg/100-assurancefuneral.svg';
import activity from '../../assets/images/svg/035-id-card.svg';
import pension from '../../assets/images/svg/111-rocking-chair.png';
import otherActivity from '../../assets/images/svg/034-clipboard.svg';
import poleEmploi from '../../assets/images/svg/066-job-interview.svg';
import peePerco from '../../assets/images/svg/060-bank-account.svg';
import locataire from '../../assets/images/svg/043-contract.svg';
import ehpad from '../../assets/images/svg/079-house-1.svg';
import credit from '../../assets/images/svg/059-cash.svg'
import animauxDomestiques from "../../assets/images/svg/003-pets.png";
import allocations from "../../assets/images/svg/004-B-allocations.svg";
import mesureDeProtection from "../../assets/images/svg/004-B-mesureDeProtection.svg";
import logementProprietaire from "../../assets/images/svg/004-B-logementProprietaire.svg";

export const ConnectionTypes = {
	notary: "Notary",
	sport: "Sport",
	internet: "Internet",
	electricityProvider: "ElectricityProvider",
	mobilePhone: "MobilePhone",
	bank: "Bank",
	multimedia: "Multimedia",
	socialSecurity: "SocialSecurity",
	taxes: "TaxCenter",
	music: "Music",
	mutual: "Mutual",
	vehicle: "Vehicle",
	insurance: "Insurance",
	waterSupplier: "WaterSupplier",
	hobby: "Hobby",
	transportTicket: "TransportTicket",
	homeMaintenance: "HomeMaintenance",
	security: "Security",
	careAesthetic: "CareAesthetic",
	homeService: "HomeService",
	paymentCard: "PaymentCard",
	technology: "Technology",
	television: "Television",
	solidarity: "Solidarity",
	socialNetworks: "SocialNetwork",
	homeInsurance: "HomeInsurance",
	other: "Other",
	facebook: "Facebook",
	youtube: "Youtube",
	instagram: "Instagram",
	whatsapp: "Whatsapp",
	snapchat: "Snapchat",
	twitter: "Twitter",
	linkedin: "LinkedIn",
	tiktok: "Tiktok",
	voitureAssurance: "VehicleInsurance",
	bateau: "Boat",
	moto: "Moto",
	scooter: "Scooter",
	loisirsInsurance: "HobbiesInsurance",
	animaux: "Animal",
	materiel: "Furniture",
	personnes: "People",
	press: "Press",
	gas: "Gas",
	lifeInsurance: "LifeInsurance",
	deathInsurance: "DeathInsurance",
	funeralInsurance: "FuneralInsurance",
	activity: "Activity",
	pension: "Pension",
	otherActivity: "OtherActivity",
	poleEmploi: "PoleEmploi",
	peePerco: "PeePerco",
	caf: "Caf",
	locataire: "Locataire",
	ehpad: "Ehpad",
	credit: "Credit",
	animauxDomestiques: "AnimauxDomestiques",
	allocations: "Allocations",
	mesureDeProtection: "MesureDeProtection",
	logementProprietaire: "LogementProprietaire",
};

export const FrenchTypes = {
	notary: "Notaires",
	sport: "Sport",
	internet: "Internet",
	electricityProvider: "Electricite",
	mobilePhone: "TelephonieMobile",
	bank: "Banques",
	multimedia: "Multimedia",
	socialSecurity: "Cpam",
	taxes: "CentreDesImpots",
	music: "Musique",
	mutual: "Mutuelles",
	vehicle: "Voiture",
	insurance: "AssuranceVehicule",
	waterSupplier: "Eau",
	hobby: "Loisirs",
	transportTicket: "TitresDeTransport",
	homeMaintenance: "EntretienMaison",
	security: "Securite",
	careAesthetic: "SoinEsthetique",
	homeService: "ServicesDomicile",
	paymentCard: "CartesDePaiement",
	technology: "Technologie",
	television: "Television",
	solidarity: "Solidarity",
	socialNetworks: "ReseauxSociaux",
	homeInsurance: "AssurancesHabitation",
	press: "Presse",
	gas: "Gaz",
	lifeInsurance: "AssurancesVie",
	other: "Autres",
	animaux: "AssurancesAnimaux",
	materiel: "AssuranceMateriels",
	loisirsInsurance: "AssuranceLoisirs",
	deathInsurance: "AssuranceDeces",
	funeralInsurance: "AssuranceObseques",
	personsInsurance: "AssurancesPersonne",
	peePerco: "PeePerco",
	activity: "Activite",
	pension: "Retraite",
	otherActivity: "AutreActivite",
	poleEmploi: "PoleEmploi",
	caf: "Caf",
	locataire: "Locataire",
	ehpad: "Ehpad",
	credit: "Credit",
	animauxDomestiques: "AnimauxDomestiques",
	allocations: "Allocations",
	mesureDeProtection: "MesureDeProtection",
	logementProprietaire: "LogementProprietaire",
};

export const Icons = {
	notary: notaire,
	sport: sport,
	internet: internet,
	electricityProvider: fournisseurelectricite,
	mobilePhone: telephonemobile,
	bank: banque,
	multimedia: multimedia,
	socialSecurity: securitesociale,
	taxes: centreimpots,
	music: musique,
	mutual: mutuelle,
	vehicle: voitures,
	insurance: assurance,
	waterSupplier: fournisseureau,
	hobby: loisirs,
	transportTicket: transport,
	homeMaintenance: entretienmaison,
	security: securite,
	careAesthetic: soinesthetique,
	homeService: domicile,
	paymentCard: cartepaiment,
	technology: tech,
	television: tv,
	solidarity: solidaire,
	socialNetworks: reseauxsociaux,
	homeInsurance: assurancehabitation,
	other: autres,
	facebook: facebook,
	youtube: youtube,
	instagram: instagram,
	snapchat: snapchat,
	twitter: twitter,
	linkedin: linkedin,
	voitureAssurance: voiture,
	bateau: bateau,
	moto: moto,
	scooter: scooter,
	loisirsInsurance: loisir,
	animaux: pet,
	materiel: mobile,
	personnes: personnes,
	press: presse,
	gas: fournisseurgas,
	lifeInsurance: assurancelife,
	deathInsurance: assurancedeath,
	funeralInsurance: assurancefuneral,
	activity: activity,
	otherActivity: otherActivity,
	poleEmploi: poleEmploi,
	peePerco: peePerco,
	locataire: locataire,
	credit: credit,
	animauxDomestiques: animauxDomestiques,
	allocations: allocations,
	mesureDeProtection: mesureDeProtection,
	logementProprietaire: logementProprietaire,
};

export const AssuranceOptions = {
    // voitureAssurance: { connectionType: ConnectionTypes.voitureAssurance, title: 'assurance voiture', desc: ['...'], icon: voiture },
    // bateau: { connectionType: ConnectionTypes.bateau, title: 'assurance bateau', desc: ['...'], icon: bateau },
    // moto: { connectionType: ConnectionTypes.moto, title: 'assurance moto', desc: ['...'], icon: moto },
    // scooter: { connectionType: ConnectionTypes.scooter, title: 'autres véhicules', desc: ['...'], icon: scooter },
    insurance: { connectionType: ConnectionTypes.insurance, title: "assurance véhicules", desc: ["Assurance voiture, bateau, moto, scooter, autres véhicules, etc."], icon: assurance },
    loisirsInsurance: { connectionType: ConnectionTypes.loisirsInsurance, title: 'assurance loisirs', desc: ['...'], icon: loisir },
    animaux: { connectionType: ConnectionTypes.animaux, title: 'assurance animaux', desc: ['...'], icon: pet },
    materiel: { connectionType: ConnectionTypes.materiel, title: 'biens et extensions de garanties', desc: ['...'], icon: mobile },
    personnes: { connectionType: ConnectionTypes.personnes, title: 'assurance des personnes', desc: ['...'], icon: personnes, tooltip: 'Protection juridique familiale, individuelle' },
    lifeInsurance: { connectionType: ConnectionTypes.lifeInsurance, title: 'assurance vie', desc: ['(Hors banque)'], icon: assurancelife },
    deathInsurance: { connectionType: ConnectionTypes.deathInsurance, title: 'assurance décès', desc: ['...'], icon: assurancedeath },
    funeralInsurance: { connectionType: ConnectionTypes.funeralInsurance, title: 'assurance obsèques', desc: ['...'], icon: assurancefuneral }
};
export const AssuranceOptionsBO = {
    voitureAssurance: { connectionType: ConnectionTypes.insurance, title: 'assurance voiture', icon: voiture },
    bateau: { connectionType: ConnectionTypes.insurance, title: 'assurance bateau', icon: bateau },
    moto: { connectionType: ConnectionTypes.insurance, title: 'assurance moto', icon: moto },
    scooter: { connectionType: ConnectionTypes.insurance, title: 'autres véhicules', icon: scooter },
    loisirsInsurance: { connectionType: ConnectionTypes.loisirsInsurance, title: 'assurance loisirs', icon: loisir },
    animaux: { connectionType: ConnectionTypes.animaux, title: 'assurance animaux', icon: pet },
    materiel: { connectionType: ConnectionTypes.materiel, title: 'biens et extensions de garanties', icon: mobile },
    personnes: { connectionType: ConnectionTypes.personnes, title: 'assurance des personnes', icon: personnes, tooltip: 'Protection juridique familiale, individuelle' },
    lifeInsurance: { connectionType: ConnectionTypes.lifeInsurance, title: 'assurance vie', desc: ['...'], icon: assurancelife },
    deathInsurance: { connectionType: ConnectionTypes.deathInsurance, title: 'assurance décès', desc: ['...'], icon: assurancedeath },
    funeralInsurance: { connectionType: ConnectionTypes.deathInsurance, title: 'assurance obsèques', desc: ['...'], icon: assurancefuneral }
};

export const SocialNetworksOptions = {
    facebook: { connectionType: ConnectionTypes.facebook, title: 'facebook', icon: facebook },
    youtube: { connectionType: ConnectionTypes.youtube, title: 'youtube', icon: youtube },
    instagram: { connectionType: ConnectionTypes.instagram, title: 'instagram', icon: instagram },
    snapchat: { connectionType: ConnectionTypes.snapchat, title: 'snapchat', icon: snapchat },
    twitter: { connectionType: ConnectionTypes.twitter, title: 'X', icon: x },
    linkedIn: { connectionType: ConnectionTypes.linkedin, title: 'linkedin', icon: linkedin },
    whatsapp: { connectionType: ConnectionTypes.whatsapp, title: 'whatsapp', icon: whatsapp },
    tiktok: { connectionType: ConnectionTypes.tiktok, title: 'tiktok', icon: tiktok },
};

export const PersonalServices = {
	sport: { connectionType: ConnectionTypes.sport, title: "sport", desc: ["Fédération", "Salle de Sport", "Club ..."], detailedDescription: "Fédérations, salles de sport, clubs...", icon: sport, order: 42 },
	internet: { connectionType: ConnectionTypes.internet, title: "internet", desc: ["Box", "Clé 3G ou 4G", "..."], detailedDescription: "Fournisseurs d'accès internet (Clé 3G ou 4G, Box)", icon: internet, order: 30 },
	press: { connectionType: ConnectionTypes.press, title: "presse", desc: ["Presse locale", "Nationale", "Internationale"], detailedDescription: "Presse locale, nationale ou internationale", icon: presse, order: 41 },
	loisirs: { connectionType: ConnectionTypes.hobby, title: "loisirs", desc: ["Jeux en ligne", "Opéra", "..."], detailedDescription: "Jeux en ligne, opéra ou cinéma", icon: loisirs, order: 37 },
	voiture: { connectionType: ConnectionTypes.vehicle, title: "voiture", desc: ["GPS", "Péage", "Parking"], detailedDescription: "Services GPS, péages ou parking", icon: voitures, order: 35 },
	transport: { connectionType: ConnectionTypes.transportTicket, title: "titre de transport", desc: ["SNCF", "Bus", "..."], detailedDescription: "SNCF, Bus...", icon: transport, order: 36 },
	maison: { connectionType: ConnectionTypes.homeMaintenance, title: "entretien maison", desc: ["Chaudière", "Ramonage", "..."], detailedDescription: "Chaudière, ramonage...", icon: entretienmaison, order: 27 },
	security: { connectionType: ConnectionTypes.security, title: "sécurité", desc: ["Homiris", "Vérisure", "..."], detailedDescription: "Téle assistance, système de sécurité, alarme...", icon: securite, order: 28 },
	esthetique: { connectionType: ConnectionTypes.careAesthetic, title: "soin et esthetique", desc: ["Body Minute", "Box beauté", "..."], detailedDescription: "Box de beauté, instituts de beauté...", icon: soinesthetique, order: 43 },
	domicile: { connectionType: ConnectionTypes.homeService, title: "services à domicile", desc: ["Repas", "Femme de menage", "..."], detailedDescription: "Repas, services de nettoyage, femme de ménage...", icon: domicile, order: 33 },
	music: { connectionType: ConnectionTypes.music, title: "musique", desc: ["Deezer", "Spotify", "Apple Music", "..."], detailedDescription: "Services de musique en streaming (nom de l'organisme)", icon: musique, order: 38 },
	cartPaiement: { connectionType: ConnectionTypes.paymentCard, title: "carte de paiement", desc: ["(non fidélité et hors banques)", "Cora", "Auchan..."], detailedDescription: "Services de paiement par carte (non fidélité et hors banques)", icon: cartepaiment, order: 12 },
	multimedia: { connectionType: ConnectionTypes.multimedia, title: "multimedia", desc: ["Netflix", "Amazon Prime", "..."], detailedDescription: "Services VOD (Netflix, Amazon Prime,...)", icon: multimedia, order: 39 },
	technology: { connectionType: ConnectionTypes.technology, title: "technologie", desc: ["Microsoft", "Adobe", "Apple (iTunes, iCloud...)"], detailedDescription: "Microsoft, Adobe, Apple (iTunes, iCloud...)", icon: tech, order: 40 },
	television: { connectionType: ConnectionTypes.television, title: "télévision", desc: ["Bouquet TV"], detailedDescription: "Bouquets TV", icon: tv, order: 31 },
	solidarity: { connectionType: ConnectionTypes.solidarity, title: "solidarité", desc: ["Dons", "Parrainage", "..."], detailedDescription: "Dons caritatifs ou Parrainages", icon: solidaire, order: 44 },
	gas: { connectionType: ConnectionTypes.gas, title: "fournisseur de gaz", desc: ["antargaz", "edf", "engie", "..."], detailedDescription: "Fournisseurs de gaz", icon: fournisseurgas, order: 26 },
	peePerco: { connectionType: ConnectionTypes.peePerco, title: "plan d'épargne", desc: ["Entreprise (PEE)", "Retraite collective (PERCO)", "..."], detailedDescription: "Retraite, Entreprise (PEE), Retraite collective (PERCO), PERE-CO, PE-I, Perco-I", icon: peePerco, order: 9 },
	ehpad: { connectionType: ConnectionTypes.ehpad, title: "ehpad", desc: ["Ehpad", "Maison de retraite", "..."], detailedDescription: "Ehpad, Maison de retraite, Mapad...", icon: ehpad, order: 20 },
	credit: { connectionType: ConnectionTypes.credit, title: "crédits à la consommation", desc: ["Cofidis", "Youdge", "..."], detailedDescription: "Organismes de crédit à la consommation...", icon: credit, order: 11 },
	other: {
		connectionType: ConnectionTypes.other,
		title: "Autres abonnements et  adhésions",
		desc: ["Ajouter vos autres abonnements", "ex: Paniers bio, associations,..." /*'Comme j\'aime', 'Nespresso',*/],
		detailedDescription: "APA, mairie de votre commune, Paniers bio, Comme j'aime, capsules Nespresso...",
		icon: autres,
		order: 45,
	},
	animauxDomestiques: { connectionType: ConnectionTypes.animauxDomestiques, title: "animaux domestiques", desc: ["I-cad", "..."], detailedDescription: "I-cad (Identification des carnivores domestiques)", icon: animauxDomestiques, order: 18 },
	allocations: {
		connectionType: ConnectionTypes.allocations,
		title: "allocations",
		desc: ["APA", "AAH", "ASPA", "..."],
		detailedDescription: "APA, AAH, etc. Veuillez renseigner le numéro de votre département.  ASPA - veuillez ajouter l'adresse du CCAS de la commune ou de la caisse de retraite",
		icon: allocations,
		order: 7,
	},
	mesureDeProtection: {
		connectionType: ConnectionTypes.mesureDeProtection,
		title: "mesure de protection",
		desc: ["Tutuelle", "Curatelle", "Habitation familiale", "..."],
		detailedDescription: "Tutelle, habilitation familiale, curatelle simple ou renforcée, sauvegarde de justice, etc. Veuillez renseigner le nom du tribunal ou de la ville",
		icon: mesureDeProtection,
		order: 1,
	},
	logementProprietaire: { connectionType: ConnectionTypes.logementProprietaire, title: "logement propriétaire", desc: ["Agence de gestion", "Syndic", "..."], detailedDescription: "Agence de gestion locative, syndic de copropriétaire, locataire, etc. ", icon: logementProprietaire, order: 21 },
};

export const OtherService = {
	activity: { connectionType: ConnectionTypes.activity, title: "En activité", desc: ["..."], detailedDescription: "Informations de votre employeur", icon: activity, order: 8 },
	pension: { connectionType: ConnectionTypes.pension, title: "Retraite", desc: ["..."], detailedDescription: "Informations de votre retaite", icon: pension, order: 8 },
	otherActivity: { connectionType: ConnectionTypes.otherActivity, title: "Autre Activité", desc: ["Tuteur ou curateur", "Trésorier", "..."], detailedDescription: "Informations de votre autre activité", icon: otherActivity, order: 8 },
	poleEmploi: { connectionType: ConnectionTypes.poleEmploi, title: "France Travail", desc: ["..."], detailedDescription: "Indiquez votre ville ou code postal.", icon: poleEmploi, order: 8 },
	locataire: { connectionType: ConnectionTypes.locataire, title: "locataire", desc: ["..."], detailedDescription: "Informations du propriétaire ou du cabinet gérant votre contrat de bail.", icon: locataire, order: 22 },
};

export const CommonServices = {
	notaire: { connectionType: ConnectionTypes.notary, title: "notaire", icon: notaire, detailedDescription: 'Veuillez renseigner le nom ou le code postal du notaire. Si pas de notaire connu, tapez "Compléter ultérieurement"', order: 2 },
	secSocial: { connectionType: ConnectionTypes.socialSecurity, title: "securité sociale", icon: securitesociale, detailedDescription: 'Veuillez renseigner votre code postal ou sélectionner le service. Pour la MSA, écrivez "MSA" dans la barre de recherche et sélectionnez la caisse correspondante.', order: 4 },
	bank: { connectionType: ConnectionTypes.bank, title: "banque", icon: banque, detailedDescription: "", order: 10 },
	mutuelle: { connectionType: ConnectionTypes.mutual, title: "mutuelle", icon: mutuelle, detailedDescription: "Veuillez renseigner le nom de l'organisme.", order: 5 },
	habitation: { connectionType: ConnectionTypes.homeInsurance, title: "assurance habitation", icon: assurancehabitation, detailedDescription: "Veuillez renseigner le nom de l'organisme.", order: 23 },
	eau: { connectionType: ConnectionTypes.waterSupplier, title: "fournisseur d'eau", icon: fournisseureau, detailedDescription: "Veuillez renseigner votre code postal ou sélectionner le service.", order: 24 },
	electricity: { connectionType: ConnectionTypes.electricityProvider, title: "fournisseur d'electricité", icon: fournisseurelectricite, detailedDescription: "Veuillez renseigner le nom de l'organisme.", order: 25 },
	mobile: { connectionType: ConnectionTypes.mobilePhone, title: "téléphone mobile", icon: telephonemobile, detailedDescription: "Opérateurs mobiles", order: 29 },
	impots: { connectionType: ConnectionTypes.taxes, title: "centre des impots", icon: centreimpots, detailedDescription: "Veuillez renseigner votre code postal ou sélectionner le service.", order: 3 },
	caf: { connectionType: ConnectionTypes.caf, title: "Caisse d'Allocations Familiales", icon: caf, detailedDescription: "Veuillez renseigner le numéro de votre département.", order: 6 },
};

export const AuxiliarOptions = {
    insurance: { connectionType: ConnectionTypes.insurance, title: 'assurance véhicules', icon: assurance, detailedDescription: 'Assurance voiture, bateau, moto, scooter, autres véhicules, etc', order: 34 },
    socialNetworks: { connectionType: ConnectionTypes.socialNetworks, title: 'reseaux sociaux', icon: reseauxsociaux, detailedDescription: '', order: 999 },
    loisirsInsurance: { connectionType: ConnectionTypes.loisirsInsurance, title: 'assurance loisirs', icon: loisir, detailedDescription: '', order: 17 },
    animaux: { connectionType: ConnectionTypes.animaux, title: 'assurance animaux', icon: pet, detailedDescription: '', order: 19 },
    materiel: { connectionType: ConnectionTypes.materiel, title: 'assurance biens et extensions de garanties', icon: mobile, detailedDescription: '', order: 32 },
    personnes: { connectionType: ConnectionTypes.personnes, title: 'assurance personnes', icon: personnes, tooltip: 'Protection juridique familiale, individuelle', detailedDescription: 'Protection juridique familiale, individuelle', order: 16 },
    lifeInsurance: { connectionType: ConnectionTypes.lifeInsurance, title: 'assurance vie', desc: ['(hors banque)'], icon: assurancelife, detailedDescription: '(HORS BANQUE)', order: 13 },
    deathInsurance: { connectionType: ConnectionTypes.deathInsurance, title: 'assurance décès', desc: ['...'], icon: assurancedeath, detailedDescription: '', order: 14 },
    funeralInsurance: { connectionType: ConnectionTypes.funeralInsurance, title: 'assurance obsèques', desc: ['...'], icon: assurancefuneral, detailedDescription: '', order: 15 }
};

export function convertConnectionTypesToServiceType(connectionType) {
    const serviceTypesMapping = {
			[ConnectionTypes.notary]: FrenchTypes.notary,
			[ConnectionTypes.sport]: FrenchTypes.sport,
			[ConnectionTypes.internet]: FrenchTypes.internet,
			[ConnectionTypes.electricityProvider]: FrenchTypes.electricityProvider,
			[ConnectionTypes.mobilePhone]: FrenchTypes.mobilePhone,
			[ConnectionTypes.bank]: FrenchTypes.bank,
			[ConnectionTypes.multimedia]: FrenchTypes.multimedia,
			[ConnectionTypes.socialSecurity]: FrenchTypes.socialSecurity,
			[ConnectionTypes.taxes]: FrenchTypes.taxes,
			[ConnectionTypes.music]: FrenchTypes.music,
			[ConnectionTypes.mutual]: FrenchTypes.mutual,
			[ConnectionTypes.vehicle]: FrenchTypes.vehicle,
			[ConnectionTypes.insurance]: FrenchTypes.insurance,
			[ConnectionTypes.waterSupplier]: FrenchTypes.waterSupplier,
			[ConnectionTypes.hobby]: FrenchTypes.hobby,
			[ConnectionTypes.transportTicket]: FrenchTypes.transportTicket,
			[ConnectionTypes.homeMaintenance]: FrenchTypes.homeMaintenance,
			[ConnectionTypes.security]: FrenchTypes.security,
			[ConnectionTypes.careAesthetic]: FrenchTypes.careAesthetic,
			[ConnectionTypes.homeService]: FrenchTypes.homeService,
			[ConnectionTypes.paymentCard]: FrenchTypes.paymentCard,
			[ConnectionTypes.technology]: FrenchTypes.technology,
			[ConnectionTypes.television]: FrenchTypes.television,
			[ConnectionTypes.solidarity]: FrenchTypes.solidarity,
			[ConnectionTypes.socialNetworks]: FrenchTypes.socialNetworks,
			[ConnectionTypes.homeInsurance]: FrenchTypes.homeInsurance,
			[ConnectionTypes.press]: FrenchTypes.press,
			[ConnectionTypes.gas]: FrenchTypes.gas,
			[ConnectionTypes.lifeInsurance]: FrenchTypes.lifeInsurance,
			[ConnectionTypes.other]: FrenchTypes.other,
			[ConnectionTypes.animaux]: FrenchTypes.animaux,
			[ConnectionTypes.materiel]: FrenchTypes.materiel,
			[ConnectionTypes.loisirsInsurance]: FrenchTypes.loisirsInsurance,
			[ConnectionTypes.deathInsurance]: FrenchTypes.deathInsurance,
			[ConnectionTypes.funeralInsurance]: FrenchTypes.funeralInsurance,
			[ConnectionTypes.activity]: FrenchTypes.activity,
			[ConnectionTypes.pension]: FrenchTypes.pension,
			[ConnectionTypes.otherActivity]: FrenchTypes.otherActivity,
			[ConnectionTypes.poleEmploi]: FrenchTypes.poleEmploi,
			[ConnectionTypes.personnes]: FrenchTypes.personsInsurance,
			[ConnectionTypes.peePerco]: FrenchTypes.peePerco,
			[ConnectionTypes.caf]: FrenchTypes.caf,
			[ConnectionTypes.locataire]: FrenchTypes.locataire,
			[ConnectionTypes.ehpad]: FrenchTypes.ehpad,
			[ConnectionTypes.credit]: FrenchTypes.credit,
			[ConnectionTypes.animauxDomestiques]: FrenchTypes.animauxDomestiques,
			[ConnectionTypes.allocations]: FrenchTypes.allocations,
			[ConnectionTypes.mesureDeProtection]: FrenchTypes.mesureDeProtection,
			[ConnectionTypes.logementProprietaire]: FrenchTypes.logementProprietaire,
		};
    return serviceTypesMapping[[connectionType]];
}

export function convertBackEndServiceTypesToFrontEndServiceType(connectionType) {
    const serviceTypesMapping = {
			[FrenchTypes.notary]: ConnectionTypes.notary,
			[FrenchTypes.sport]: ConnectionTypes.sport,
			[FrenchTypes.internet]: ConnectionTypes.internet,
			[FrenchTypes.electricityProvider]: ConnectionTypes.electricityProvider,
			[FrenchTypes.mobilePhone]: ConnectionTypes.mobilePhone,
			[FrenchTypes.bank]: ConnectionTypes.bank,
			[FrenchTypes.multimedia]: ConnectionTypes.multimedia,
			[FrenchTypes.socialSecurity]: ConnectionTypes.socialSecurity,
			[FrenchTypes.taxes]: ConnectionTypes.taxes,
			[FrenchTypes.music]: ConnectionTypes.music,
			[FrenchTypes.mutual]: ConnectionTypes.mutual,
			[FrenchTypes.vehicle]: ConnectionTypes.vehicle,
			[FrenchTypes.insurance]: ConnectionTypes.insurance,
			[FrenchTypes.waterSupplier]: ConnectionTypes.waterSupplier,
			[FrenchTypes.hobby]: ConnectionTypes.hobby,
			[FrenchTypes.transportTicket]: ConnectionTypes.transportTicket,
			[FrenchTypes.homeMaintenance]: ConnectionTypes.homeMaintenance,
			[FrenchTypes.security]: ConnectionTypes.security,
			[FrenchTypes.careAesthetic]: ConnectionTypes.careAesthetic,
			[FrenchTypes.homeService]: ConnectionTypes.homeService,
			[FrenchTypes.paymentCard]: ConnectionTypes.paymentCard,
			[FrenchTypes.technology]: ConnectionTypes.technology,
			[FrenchTypes.television]: ConnectionTypes.television,
			[FrenchTypes.solidarity]: ConnectionTypes.solidarity,
			[FrenchTypes.socialNetworks]: ConnectionTypes.socialNetworks,
			[FrenchTypes.homeInsurance]: ConnectionTypes.homeInsurance,
			[FrenchTypes.press]: ConnectionTypes.press,
			[FrenchTypes.gas]: ConnectionTypes.gas,
			[FrenchTypes.lifeInsurance]: ConnectionTypes.lifeInsurance,
			[FrenchTypes.other]: ConnectionTypes.other,
			[FrenchTypes.animaux]: ConnectionTypes.animaux,
			[FrenchTypes.materiel]: ConnectionTypes.materiel,
			[FrenchTypes.loisirsInsurance]: ConnectionTypes.loisirsInsurance,
			[FrenchTypes.deathInsurance]: ConnectionTypes.deathInsurance,
			[FrenchTypes.funeralInsurance]: ConnectionTypes.funeralInsurance,
			[FrenchTypes.activity]: ConnectionTypes.activity,
			[FrenchTypes.pension]: ConnectionTypes.pension,
			[FrenchTypes.otherActivity]: ConnectionTypes.otherActivity,
			[FrenchTypes.poleEmploi]: ConnectionTypes.poleEmploi,
			[FrenchTypes.personsInsurance]: ConnectionTypes.personnes,
			[FrenchTypes.peePerco]: ConnectionTypes.peePerco,
			[FrenchTypes.caf]: ConnectionTypes.caf,
			[FrenchTypes.locataire]: ConnectionTypes.locataire,
			[FrenchTypes.ehpad]: ConnectionTypes.ehpad,
			[FrenchTypes.credit]: ConnectionTypes.credit,
			[FrenchTypes.animauxDomestiques]: ConnectionTypes.animauxDomestiques,
			[FrenchTypes.allocations]: ConnectionTypes.allocations,
			[FrenchTypes.mesureDeProtection]: ConnectionTypes.mesureDeProtection,
			[FrenchTypes.logementProprietaire]: ConnectionTypes.logementProprietaire,
		};
    return serviceTypesMapping[[connectionType]];
}

export const PensionProfessionalCategoryMapping = [
	{
		title: "Salarié",
		options: [
			{ title: "Salarié de l'agriculture", value: "SalarieAgriculture" },
			{ title: "Salarié", value: "Salarie" },
			{ title: "Salarié de l'industrie du commerce et des services", value: "CommerceEtService" },
			{ title: "Salarié des industries électriques et gazières", value: "ElectriqueEtGazieres" },
			{ title: "Agent non titulaire de l'Etat et des collectivités publiques", value: "AgentsCollectivitePubliques" },
			{ title: "Personnel navigant de l'aviation civile", value: "AviationCivile" },
		],
	},
	{
		title: "Fonctionnaires",
		options: [
			{ title: "Fonctionnaire de l'Etat, magistrat et militaire", value: "FonctionnairesEtatMagistratsEtMilitaires" },
			{ title: "Agent de la fonction publique territoriale et hospitalière", value: "TerritorialesEtHopistalière" },
			{ title: "Ouvrier de l'Etat", value: "OuvriersEtat" },
		],
	},
	{
		title: "Travailleurs indépendants",
		options: [
			{ title: "Exploitant agricole", value: "ExploitantsAgricoles" },
			{ title: "Artisan commercant et industriel", value: "ArtisanCommercantIndustriels" },
			{ title: "Profession libérale", value: "ProfessionsLiberales" },
			{ title: "Artiste, auteur d'oeuvres originales", value: "ArtistesAuteurs" },
			{ title: "Membres de cultes", value: "MembresCultes" },
		],
	},
	{
		title: "Autres",
		options: [{ title: "Autres", value: "Autres" }],
	},
];

export const ProfessionOptions = { retired: 'Retired', active: 'Employed', unemployed: 'PoleEmploi', other: 'OtherActivity', none: 'None' };

export function isSocialNetwork(str) {
    if (str === ConnectionTypes.facebook || str === ConnectionTypes.youtube || str === ConnectionTypes.instagram || str === ConnectionTypes.whatsapp ||
        str === ConnectionTypes.snapchat || str === ConnectionTypes.twitter || str === ConnectionTypes.linkedin || str === ConnectionTypes.tiktok ||
        str === ConnectionTypes.socialNetworks) {
        return true;
    }
    return false;
}

export function isInsurance(str) {
    if (str === ConnectionTypes.voitureAssurance || str === ConnectionTypes.bateau || str === ConnectionTypes.moto || str === ConnectionTypes.scooter) {
        return true;
    }
    return false;
}